import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import EnquiryListingContext from '../../../../providers/EnquiryListing';
import EnquiryQuestion from '../EnquiryQuestion/EnquiryQuestion.component';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import { useForm } from 'react-final-form';

import './EnquiryQuestions.styles.scss';
import './EnquiryQuestions.styles.responsive.scss';

type EnquiryQuestionsProps = {
  className?: string;
  invalid: boolean; // from Form render, don't use useFormState
  onBack: () => void;
};

const EnquiryQuestions: React.FC<EnquiryQuestionsProps> = (props) => {
  const { className, invalid, onBack } = props;

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const { listing } = useContext(EnquiryListingContext);

  const { qualificationQuestions } = listing?.dealRoom || {};

  const { submit } = useForm();

  const classes = classNames('enquiry-questions', className);

  const { t } = useTranslation();

  const isFirstQuestion = currentQuestionIndex === 0;
  const isLastQuestion =
    currentQuestionIndex === qualificationQuestions.length - 1;

  const onPreviousQuestion = useCallback(() => {
    isFirstQuestion ? onBack() : setCurrentQuestionIndex((prev) => prev - 1);
  }, [isFirstQuestion, onBack]);

  const onNextQuestion = useCallback(() => {
    if (invalid) {
      submit();
      return;
    }

    isLastQuestion ? submit() : setCurrentQuestionIndex((prev) => prev + 1);
  }, [invalid, isLastQuestion, submit]);

  return (
    <div className={classes}>
      <EnquiryQuestion
        name={`questions[${currentQuestionIndex}]`}
        question={qualificationQuestions[currentQuestionIndex]}
      />

      <div className="actions">
        <Button
          variant="icon"
          icon={ArrowleftIcon}
          onClick={onPreviousQuestion}
        />

        <div>
          <span>
            {t('questionXOfY', {
              total: qualificationQuestions.length,
              current: currentQuestionIndex + 1,
            })}
          </span>
          <Button onClick={onNextQuestion}>
            {t(isLastQuestion ? 'submit' : 'nextQuestion')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnquiryQuestions;
